import * as React from 'react';

import moment from 'moment';

import {isToday, isYesterday} from 'nutshell-core/date-time';

import {FormattedTimestamp} from '../timestamp/formatted-timestamp';
import {RelativeTimestamp} from '../timestamp/relative-timestamp';

type Props = {
    timestamp: any;
    relativeLowercase?: boolean;
};

export function TableTimestampComponent(props: Props) {
    const {timestamp} = props;

    const momentTimestamp = timestamp && timestamp > 0 ? moment.unix(timestamp) : undefined;
    if (!momentTimestamp) return null;

    const TimestampComponent =
        isToday(momentTimestamp) || isYesterday(momentTimestamp) ? (
            <RelativeTimestamp
                datetime={timestamp}
                format='calendar'
                lowercase={props.relativeLowercase}
            />
        ) : (
            <FormattedTimestamp
                datetime={timestamp}
                format={FormattedTimestamp.formats.longMonthDayWithYear}
                showDetailedPopover={true}
            />
        );

    return TimestampComponent;
}
